import { Flex, FlexProps, HStack, Spacer } from "@chakra-ui/react";
import * as React from "react";

import { ProgressCircleRing, ProgressCircleRoot } from "./progress-circle";

interface PageProps extends FlexProps {
  children?: React.ReactNode;
  loading?: boolean;
}

export default function Page({ children, loading, ...rootProps }: PageProps) {
  return (
    <Flex flex="1" {...rootProps}>
      {loading ? (
        <HStack flex="1">
          <Spacer />
          <ProgressCircleRoot value={null}>
            <ProgressCircleRing />
          </ProgressCircleRoot>
          <Spacer />
        </HStack>
      ) : (
        children
      )}
    </Flex>
  );
}
